import { useQuery } from '@tanstack/react-query';
import { maintenanceApi } from '../api';
import { MaintenanceStatus } from '../models';
import { getErrorMessage } from '@/api/unwrapQuery';
import { queryKeys } from '@/api/queryKeys';

/**
 * Polls the public maintenance status endpoint.
 * Used by the global maintenance gate to block regular users during maintenance.
 */
export const useMaintenanceStatus = ({ enabled: pollEnabled = true } = {}) => {
    const query = useQuery({
        queryKey: queryKeys.maintenance.status,
        queryFn: () => maintenanceApi.getStatus(),
        select: (data) => new MaintenanceStatus(data),
        refetchInterval: 60000,
        refetchOnWindowFocus: true,
        staleTime: 30000,
        retry: 1,
        enabled: pollEnabled,
    });

    return {
        status: query.data || new MaintenanceStatus({}),
        enabled: Boolean(query.data?.enabled),
        loading: query.isLoading,
        error: getErrorMessage(query.error, 'خطا در دریافت وضعیت سرویس'),
        refresh: query.refetch,
    };
};

export default useMaintenanceStatus;
